import { render, staticRenderFns } from "./tableMixins.vue?vue&type=template&id=4b6c4b6b&scoped=true"
import script from "./tableMixins.vue?vue&type=script&lang=js"
export * from "./tableMixins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6c4b6b",
  null
  
)

export default component.exports